<script setup lang="ts">
import type { Level } from "@tiptap/extension-heading";
import type { CommandItemBaseProps } from "./types";
import { Heading1Icon, Heading2Icon, Heading3Icon, HeadingIcon } from "lucide-vue-next";
import { computed } from "vue";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps & {
  level: Level;
}>();

const icon = computed(() => {
  const level = props.level;
  if (level === 1) return Heading1Icon;
  if (level === 2) return Heading2Icon;
  if (level === 3) return Heading3Icon;
  return HeadingIcon;
});

const title = computed(() => {
  const level = props.level;
  if (level === 1) return "Large heading";
  if (level === 2) return "Medium heading";
  if (level === 3) return "Small heading";
  return `Heading ${level}`;
});

const shortcut = computed(() => {
  const level = props.level;
  if (level === 1) return "#";
  if (level === 2) return "##";
  if (level === 3) return "###";
  return `Heading ${level}`;
});

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ escapeList: true, onlyIfEmpty: true }))
    .setHeading({ level: props.level })
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="icon"
    :shortcut="shortcut"
    @click="run"
    @keydown.enter="run"
  >
    {{ title }}
  </SuggestionListItem>
</template>
